module.exports = __webpack_public_path__ + "static/colleen-rowan-zoom-bbf5b8bbcdee01cb7202d69ea561d31e.jpg";